import LongText from '../Elements/LongText';
import React from 'react';
import urlHelper from '../Helpers/urlHelper';
import dateTimeHelper from '../Helpers/datetimeHelper';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import ClientPaymentService from '../Services/ClientPaymentService';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';

export default class ClientPaymentItem {
  constructor(item) {
    if (item) {
      this.CpId = item.cpId;
      this.CpCcname = item.cpCcname;
      this.CpLptdesc = item.cpLptdesc;
      this.CpPaymentDate = item.cpPaymentDate;
      this.CpCheckNumber = item.cpCheckNumber;
      this.CpAmountPaid = item.cpAmountPaid;
      this.CpBalance = item.cpBalance;
      this.CpIsReversed = item.cpIsReversed;
      this.CpRcycode = item.cpRcycode;
      this.CpRcysymbol = item.cpRcysymbol;
      this.CpDocdate = item.cpDocdate;
      this.CpRcyid = item.cpRcyid;
      this.CpReceivingOfficeName = item.cpReceivingOfficeName;
      this.CpNotes = item.cpNotes;
      this.CpAmountApplied = item.cpAmountApplied;
      this.CpStatus = item.cpStatus;
      this.CpAmountRefunded = item.cpAmountRefunded;
      this.Selected = false;
      return;
    }
    this.CpId = '';
    this.CpCcname = '';
    this.CpLptdesc = '';
    this.CpPaymentDate = '';
    this.CpCheckNumber = '';
    this.CpAmountPaid = '';
    this.CpBalance = '';
    this.CpIsReversed = '';
    this.CpRcycode = '';
    this.CpRcysymbol = '';
    this.CpDocdate = '';
    this.CpRcyid = '';
    this.CpReceivingOfficeName = '';
    this.CpNotes = '';
    this.CpAmountApplied = '';
    this.CpStatus = '';
    this.CpAmountRefunded = '';
    this.Selected = false;
  }

  static MoneyFields = ['CpAmountPaid', 'CpBalance', 'CpAmountApplied', 'CpAmountRefunded'];
  static DateFields = ['CpPaymentDate', 'CpDocdate'];

  static Currency() {
    return 'CpRcycode';
  }

  static MoneyFieldsSecondary = ['CpAmountPaid', 'CpBalance', 'CpAmountApplied', 'CpAmountRefunded'];
  static CurrencySecondary() {
    return 'CpRcycode';
  }

  static nameOfTheItemDetailList() {
    return 'Client Payment';
  }

  static serviceFunctionForListTable = (item) => ClientPaymentService.GetByPaymentId(item.CpId);

  static FieldsToShowInListTable = [
    {
      data: [
        { name: '-message-', label: 'General Information', className: 'text-left' },
        { label: 'Client', name: 'CpCcname', className: 'text-left' },
        { label: 'Payment Type', name: 'CpLptdesc', className: 'text-left' },
        {
          label: 'Entry Date',
          name: (item) => (item.CpPaymentDate ? dateTimeHelper.toYYYYsMMsDD(item.CpPaymentDate, '/') : ''),
          className: 'text-left',
        },
        { label: 'Receiving Office', name: 'CpReceivingOfficeName', className: 'text-left' },
        { label: 'Payment Reference #', name: 'CpCheckNumber', className: 'text-left' },
        {
          label: 'Payment Instrument Date',
          name: (item) => (item.CpDocdate ? dateTimeHelper.toYYYYsMMsDD(item.CpDocdate, '/') : ''),
          className: 'text-left',
        },
        { label: 'Amount Paid', name: 'CpAmountPaid', className: 'text-left' },
        {
          label: 'Notes',
          name: 'CpNotes',
          width: TabListTableCellWidthEnum.TwoLines,
          className: 'text-left',
          contentHasHtml: true,
        },
        { label: 'Applied', name: 'CpAmountApplied', className: 'text-left' },
        { label: 'Status', name: 'CpStatus', className: 'text-left' },
        { label: '', name: '', className: 'text-left' },
        { label: 'Refunded', name: 'CpAmountRefunded', className: 'text-left' },
        { label: '', name: '', className: 'text-left', width: TabListTableCellWidthEnum.Double },
        { label: 'Remaining Balance', name: 'CpBalance', className: 'text-left' },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: ClientPaymentItem.getSelectedCellHeader,
        orderById: '',
        data: ClientPaymentItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      { label: 'Client Payment ID', orderById: 'CpId', data: ClientPaymentItem.GetDetailCellContent, minWidth: 20 },
      { label: 'Client', orderById: 'CpCcname', data: ClientPaymentItem.getClientCellContent, minWidth: 40 },
      {
        label: 'Payment Type',
        orderById: 'CpLptdesc',
        data: 'CpLptdesc',
        minWidth: 20,
      },
      {
        label: 'Entry Date',
        orderById: 'CpPaymentDate',
        data: 'CpPaymentDate',
        minWidth: 40,
      },
      {
        label: 'Payment Reference #',
        orderById: 'CpCheckNumber',
        data: ClientPaymentItem.getPaymentReferenceCellContent,
        minWidth: 20,
      },
      { label: 'Amount Paid', orderById: 'CpAmountPaid', data: 'CpAmountPaid', minWidth: 20 },
      { label: 'Remaining Balance', orderById: 'CpBalance', data: 'CpBalance', minWidth: 20 },
      {
        label: 'Reversed?',
        orderById: 'CpIsReversed',
        data: 'CpIsReversed',
        minWidth: 20,
      },
      {
        label: ' ',
        orderById: '',
        data: ClientPaymentItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static getPaymentReferenceCellContent(item) {
    return (
      <LongText
        text={item.CpCheckNumber ? item.CpCheckNumber : ' '}
        maxLength={120}
      />
    );
  }

  static getClientCellContent(item) {
    return (
      <LongText
        text={item.CpCcname ? item.CpCcname : ' '}
        maxLength={80}
      />
    );
  }

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.CpId,
      '',
      '',
      'clientpaymentdetails',
      `id=${item.CpId}`,
      'Open up in a new tab'
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Refund',
            iconName: 'fa-solid fa-money-bill-transfer',
            roleKey: 'clientpayment_refund',
            onClick: () => ClientPaymentItem.refundFunction(item.CiId, item),
            disabled: item.CpBalance <= 0 || item.CpIsReversed === 'Y',
          },
          {
            text: 'Reverse',
            iconName: 'fa-solid fa-clock-rotate-left',
            roleKey: 'clientpayment_reverse',
            onClick: () => ClientPaymentItem.reverseFunction(item.CiId, item),
            disabled: item.CpAmountRefunded > 0 || item.CpIsReversed === 'Y',
          },
        ]}
      />
    );
  }

  static refundFunction(id, item) {
    alert('Empty function!');
  }

  static reverseFunction(id, item) {
    alert('Empty function!');
  }

  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          ClientPaymentItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={ClientPaymentItem.selectedStatus()}
        onChange={(e) => {
          ClientPaymentItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }
}
